<template>
    <div>
        <div v-bind:class="ContentBlockBaseProps.Class" v-bind:style="ContentBlockBaseProps.Style">
            <div class="overflow-hidden" :class="BlockProps.Shadow? 'shadow-lg' : ''" :style="{'background-color' : BlockProps.BGColor + ' !important'}">
                <div class="container position-relative" v-bind:style="ContainerPadding">
                    
                    <div style="z-index:0;margin-top:50px;" class="position-absolute top-0 start-0 w-100 w-lg-65 h-65 h-lg-100 bg-light rounded-3 ms-n5" v-bind:style="{'background-color' : BlockProps.HighlightColor + ' !important'}"></div>

                    <div class="row" :style="{ 'flex-direction': BlockProps.Flipped ? 'row-reverse' : 'row' }">
                        <div class="col-lg-5 mb-7 mb-lg-0 align-self-end" style="position: relative;">

                            <omnieditor :iseditmode="iseditmode" editortype="tinymce" :init="EditorConfig" keyDown v-model="BlockProps.Title" tag-name="h2" class="text-center">
                            </omnieditor>

                            <div class="d-none d-lg-flex justify-content-center mt-7" style="width:15rem;">
                                <omnieditor :iseditmode="iseditmode" editortype="tinymce" :init="EditorConfig" keyDown v-model="BlockProps.BgImg">
                                </omnieditor>
                            </div>
                        </div><!-- End Col -->
                        <div class="col-lg-7 align-self-lg-center">
                            <div class="row">
                                <div class="col-lg-6 mb-4" v-for="card in BlockProps.Cards">
                                    <!-- Card -->
                                    <div class="card card-transition h-100 border-primary">
                                        <omnieditor :iseditmode="iseditmode" editortype="tinymce" :init="EditorConfig" keyDown v-model="card.content" tag-name="div" class="card-body">
                                        </omnieditor>
                                    </div><!-- End Card -->
                                </div><!-- End Col -->
                            </div><!-- End Row -->
                        </div><!-- End Col -->
                    </div><!-- End Row -->

                </div>
            </div>

        </div>

        <div v-if="iseditmode" style="z-index:300" class="modal" :id="'editor' + BlockProps.UId" tabindex="-1" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
            <div class="modal-dialog modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Options</h5>
                    </div>
                    <div class="modal-body">
                        <hr style="margin: 0px; margin-bottom:10px;" />
                        <propertybaseeditors :blockprops="BlockProps" :additionalcfg="AdditionalCfg"></propertybaseeditors>
                        <propertytogglededitor propertyname="Shadows" :blockprops="BlockProps" prompt="Inner Drop Shadows"></propertytogglededitor>

                        <div>
                            <div class="row">
                                <div class="col col-12">
                                    <label for="customRange2" class="form-label">Number of Cards (1 - 6)</label>
                                    <div class="input-group mb-3">
                                        <button @click="RemoveCard" class="btn btn-outline-secondary" type="button">-</button>
                                        <input readonly style="text-align:center;" min="1" max="6" type="number" class="form-control" v-model="NumCardsUI">
                                        <button @click="AddCard" class="btn btn-outline-secondary" type="button">+</button>
                                    </div>
                                    <div class="progress" style="height: 20px;">
                                        <div class="progress-bar" role="progressbar" :style="{'width': NumCardsUIFilled}" :aria-valuenow="NumCardsUIFilled" aria-valuemin="0" aria-valuemax="6">{{NumCardsUI}} / 6</div>
                                    </div>
                                </div>
                                <hr style="margin-top: 10px; margin-bottom:5px;" />
                            </div>

                            <propertytogglededitor propertyname="Flipped" :blockprops="BlockProps" prompt="Flip Layout"></propertytogglededitor>

                            <propertycoloreditor :propertyname="'HighlightColor'" :blockprops="BlockProps" :prompt="'Highlight Color'"></propertycoloreditor>

                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-secondary" data-bs-dismiss="modal">Done</button>
                        <!--<button type="button" class="btn btn-sm btn-primary">Save changes</button>-->
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import EventHub from '/src/Util/EventHub.js';
    import ContentBlockBase from '/src/components/ContentCreator/ContentBlockBase.vue'
    import { computed, ref, nextTick } from 'vue'


    import Editor from '@tinymce/tinymce-vue'

    // Swiper components


    export default {
        inheritAttrs: false,
        name: 'CardsOne',
        mixins: [ContentBlockBase],
        props: [],
        components: {
            'editor': Editor,

        },
        computed:
        {
            NumCardsUIFilled(){
                return `${Math.floor(this.NumCardsUI / 6 * 100)}%`;
            }
        },
        watch: {
            NumCardsUI: function (newVal, oldVal) {
                
                while (newVal < this.BlockProps.Cards.length) {
                    this.BlockProps.Cards.pop();
                }

                while (newVal > this.BlockProps.Cards.length) {
                    var newCard = JSON.stringify(this.Store.DefaultBlockProps[this.ComponentType].Cards[0]);
                    newCard = JSON.parse(newCard)
                    this.BlockProps.Cards.push(newCard);
                }
            }
        },
        data() {
            return {  
                NumCardsUI: 4
            };
        },
        methods:
        {
            AddCard: function () {
                this.NumCardsUI = Math.min(this.NumCardsUI + 1, 6);
            },
            RemoveCard: function () {
                this.NumCardsUI = Math.max(this.NumCardsUI - 1, 1);
            },
            OnSlideBackgroundUploaded: function (args) {
                if(args.success){
                    if(args.idx >= this.BlockProps.Slides.length){
                        return;
                    }
                    if(args.url){
                        this.BlockProps.Slides[args.idx].img = args.url;                    
                    }
                }
                
                this.EditProperties();
            },
            EditProperties: function () {
                var id = '#editor' + this.BlockProps.UId;
                var modalEl = document.querySelector(id);
                if (modalEl == null) {
                    return;
                }
                var modal = bootstrap.Modal.getOrCreateInstance(modalEl); // Returns a Bootstrap modal instance
                modal.show();
            },
            UploadNewSlideBackground: function(idx){
                this.HideEditProperties();
                var args = {};  
            
                args.ExistingFileURL = this.BlockProps.Slides[idx].img;
                args.CompleteCallback = "OnSlideBackgroundUploaded-" + this.BlockProps.UId;
                args.CompleteCallbackData = {idx: idx, url: ''}; // this will be sent back in the callback
                args.Prompt = `Background image for slide ${idx + 1}`;
                EventHub.$emit('UploadNewAssetBlockConfig', args);
            }
        },

        setup(props, context)
        {             
            return {} // anything returned here will be available for the rest of the component
        },
        created()
        {           
            EventHub.$on('OnSlideBackgroundUploaded-' + this.BlockProps.UId, this.OnSlideBackgroundUploaded);      
        },
        beforeUnmount()
        {
            EventHub.$off('OnSlideBackgroundUploaded-' + this.BlockProps.UId, this.OnSlideBackgroundUploaded);      
        },
        mounted() {
            this.NumCardsUI = this.BlockProps?.Cards.length ?? 0;
            nextTick().then(() => {
     
            });
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .ce-block .ce-block--focused {
        border: 1px dashed #cbcbcb !important
    }
    #editorjs {
        color: green;
    }

    .mce-content-body [data-mce-selected=inline-boundary] {
        background-color: unset !important;
    }

    .card:hover {
        box-shadow: 0 1rem 1.75rem 0 rgba(45,55,75,.1);
    }
</style>

